import React, { isValidElement, version } from 'react';

import { ForwardRef, isMemo } from 'react-is';

const ReactMajorVersion = Number(version.split('.')[0]);

export function isFragment(child: any): boolean {
    return child && React.isValidElement(child) && child.type === React.Fragment;
}

export const supportRef = (nodeOrComponent: any): boolean => {
    if (!nodeOrComponent) {
        return false;
    }

    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if (
        isValidElement(nodeOrComponent) &&
        !isFragment(nodeOrComponent) &&
        ReactMajorVersion >= 19
    ) {
        return true;
    }

    const type = isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

    // Function component node
    if (typeof type === 'function' && !type.prototype?.render && type.$$typeof !== ForwardRef) {
        return false;
    }

    // Class component (in case any library still using class component)
    if (
        typeof nodeOrComponent === 'function' &&
        !nodeOrComponent.prototype?.render &&
        nodeOrComponent.$$typeof !== ForwardRef
    ) {
        return false;
    }

    return true;
};
